import { Theme, useMediaQuery } from "@mui/material"

export interface IUseScreenSize {
    isMob: boolean
    isTablet: boolean
    isTabletOrMob: boolean
    isLg: boolean
    isXl: boolean
}

/**
 * Hook for abstracting media queries for responsive design
 */
export const useScreenSize = (): IUseScreenSize => ({
    // Is mobile
    isMob: useMediaQuery((theme: Theme) => theme.breakpoints.down("sm")),
    isTablet: useMediaQuery((theme: Theme) =>
        theme.breakpoints.between("sm", "md")
    ),
    isTabletOrMob: useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md")
    ),
    isLg: useMediaQuery((theme: Theme) => theme.breakpoints.up("lg")),
    isXl: useMediaQuery((theme: Theme) => theme.breakpoints.up("xl")),
})
